import Axios from 'axios'
import requestPrefix from '../requestPrefix'
export default {

  listByAlarm(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectProcess/listByAlarm',
      method: 'get',
      params: params
    })
  },

  progressDetail(id) {
    return Axios({
      url: requestPrefix.projectUrl + `/projectProcess/progressDetail/${id}`,
      method: 'get'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/progressPlan/index.js